import { NavLink } from 'react-router-dom';
import { navLinks } from '../../mock';

const HeaderNavLink = ({ link, mobile }) => (
  <NavLink
    data-testid={`${mobile ? 'mobile' : 'header'}-nav-${link.id}`}
    to={link.to} end={link.to === '/'}
    className={({ isActive }) => mobile
      ? `text-left text-[16px] ${isActive ? 'text-accent' : 'text-white/70'}`
      : `relative text-[15px] transition-colors duration-300 pb-1 ${isActive ? 'text-white' : 'text-white/55 hover:text-white'}`}
  >
    {({ isActive }) => <>{link.label}{!mobile && <span className={`absolute left-0 right-0 -bottom-0.5 h-[2px] bg-primary transition-all duration-300 ${isActive ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'}`} />}</>}
  </NavLink>
);

export const QuoteButton = ({ mobile = false, onClick }) => (
  <button
    data-testid={`${mobile ? 'mobile' : 'header'}-quote-button`} type="button" onClick={onClick}
    className={`${mobile ? 'mt-2 w-fit' : 'hidden sm:inline-flex items-center justify-center'} px-6 py-3 rounded-full bg-gradient-to-b from-primary to-primary-hover text-primary-foreground text-[12px] font-semibold tracking-[0.15em] hover:from-primary-hover hover:to-primary-hover transition-all duration-300 shadow-lg shadow-primary/20 hover:-translate-y-0.5`}
  >TEKLIF ALIN</button>
);

export const DesktopNavigation = () => (
  <nav aria-label="Ana gezinme" className="hidden md:flex items-center gap-9 absolute left-1/2 -translate-x-1/2">
    {navLinks.map((link) => <HeaderNavLink key={link.id} link={link} />)}
  </nav>
);

export const MobileNavigation = ({ requestQuote }) => (
  <nav id="mobile-navigation" data-testid="mobile-navigation" aria-label="Mobil gezinme" className="md:hidden bg-card/95 backdrop-blur-xl border-t border-border">
    <div className="px-6 py-6 flex flex-col gap-5">
      {navLinks.map((link) => <HeaderNavLink key={link.id} link={link} mobile />)}
      <QuoteButton mobile onClick={requestQuote} />
    </div>
  </nav>
);